import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs'
import {IDriverType} from '../interfaces'
import {tap} from "rxjs/operators";
import {DriverTypeHttpService} from "@app/administration/driver-types/services/driver-types-http.service";

@Injectable()
export class DriverTypesService {
    private driverTypesSubject = new BehaviorSubject<IDriverType[]>([]);
    public driverTypes$ = this.driverTypesSubject.asObservable();

    private activeDriverTypeSubject = new BehaviorSubject<IDriverType>(null);
    public activeDriverType$ = this.activeDriverTypeSubject.asObservable();

    constructor(private driverTypeHttp: DriverTypeHttpService) {
    }

    public getDriverTypes(): Observable<IDriverType[]> {
        return this.driverTypeHttp.getDriverTypes()
            .pipe(tap(driverTypes => {
                this.driverTypesSubject.next(driverTypes);
            }))
    }

    public setActiveDriverType(driverType: IDriverType) {
        this.activeDriverTypeSubject.next(driverType)
    }

    public submitDriverType(driverType: IDriverType, id?: number): Observable<IDriverType> {
        if (id) {
            return this.driverTypeHttp.editDriverType(id, driverType)
                .pipe(
                    tap((newDriverType) => {
                        this.activeDriverTypeSubject.next(newDriverType)

                        this.driverTypesSubject.next(this.driverTypesSubject.value.map(d => {
                            if (d.id === newDriverType.id) {
                                return newDriverType
                            } else {
                                return d
                            }
                        }))
                    }))
        } else {
            return this.driverTypeHttp.createDriverType(driverType)
                .pipe(
                    tap(driverType => {
                        this.activeDriverTypeSubject.next(driverType)
                        this.driverTypesSubject.next([...this.driverTypesSubject.value, driverType])
                    }))
        }
    }

    public deleteDriverType(id: number): Observable<string> {
        return this.driverTypeHttp.deleteDriverType(id)
            .pipe(tap(() => {
                this.activeDriverTypeSubject.next(null)
                this.driverTypesSubject.next(this.driverTypesSubject.value.filter(driverType => driverType.id !== id))
            }))
    }

    public addBlankDriverType() {
        this.activeDriverTypeSubject.next({
            id: null,
            name: null,
            command_start: null,
            settings_pool: [],
            has_tree: false
        })
    }
}
